// Generat automat din README.md
import React from 'react';
import AppRoutes from './routes';
import './index.css';

function App() {
  return (
    <div className="App">
      <AppRoutes />
    </div>
  );
}

export default App;